import { render, staticRenderFns } from "./TasksSkeleton.vue?vue&type=template&id=4b2820e3&scoped=true"
import script from "./TasksSkeleton.vue?vue&type=script&lang=js"
export * from "./TasksSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TasksSkeleton.vue?vue&type=style&index=0&id=4b2820e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b2820e3",
  null
  
)

export default component.exports